import styled from "styled-components";
import { mobile, tablet, portalColors } from "src/components";

export const Container = styled.div`
    background: ${portalColors.surface};
    color: ${portalColors.text};
    width: 100%;
    max-width: 557px;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    box-shadow: ${portalColors.shadow};
    border: 1px solid ${portalColors.border};
    border-radius: 16px;
    opacity: 1;
    gap: 10px;
    padding: 1em 1em 0.5em 1em;
    box-sizing: border-box;
  
    @media (max-width: 768px) {
        flex-direction: column;
        max-width: 100%;
        padding: 1.5em;
    }
`;

export const Card = styled.div`
    background: ${portalColors.surface};
    box-shadow: ${portalColors.shadow};
    border: 1px solid ${portalColors.border};
    border-radius: 16px;
    opacity: 1;
    color: ${portalColors.text};
    width: 199px;
    display: row;
    max-width: 26.375rem;
    max-height: 130px;
    padding: 14px 20px 20px 20px;
    box-sizing: border-box;
    position: relative;
    ${tablet`
        width: 199px;
    `};

    ${mobile`
        width: unset;
    `};
`;

export const Label = styled.div`
    font-weight: 500;
    font-size: 14px;
`;

export const Number = styled.div`
    font-size: 2rem;
    font-weight: 700;
    font-family: Manrope, Helvetica, sans-serif;
    margin: 0;
    text-align: left;
`;

export const GetManageButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 140px;
    height: 39px;
    background: ${portalColors.text};
    box-shadow: none;
    border-radius: 8px;
    border: none;
    opacity: 1;
    font-family: 'Manrope', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.2;
    color: #FFFFFF;
    cursor: pointer;
    text-align: center;
    white-space: nowrap;

    img {
        flex: 0 0 auto;
        margin-left: 0 !important;
    }
`;

export const HeaderBox = styled.div`
    display: flex;
    flex-direction: ${p => p.flexDirection || "row"};
    justify-content: ${p => p.justifyContent || "flex-start"};
    align-items: ${p => p.alignItems || "flex-start"};
    gap: ${p => p.gap};
    width: ${p => p.width || "100%"};
    max-width: ${p => p.maxWidth};
    margin-top: ${p => p.marginTop || "1rem"};
    margin-bottom: ${p => p.marginBottom};
    padding: 0.9rem 1rem;
    box-sizing: border-box;
    background: ${portalColors.surface};
    border: 1px solid ${portalColors.border};
    border-radius: 16px;
    box-shadow: ${portalColors.shadow};

    @media (max-width: 1440px) {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    }
`;
